<template>
  <v-container class="tiendas-page">
    <div class="tiendas-top">
      <h1 class="page-title">Tiendas</h1>
      <p class="page-subtitle">Elegí dónde querés pedir</p>
    </div>

    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
      class="tiendas-skeleton"
    />

    <v-alert
      v-if="accesoDenegadoUsuario && !loading"
      type="warning"
      dense
      outlined
      class="tiendas-alert mb-4"
    >
      Denegaste el acceso a tu ubicación. Vamos a listar las tiendas sin ordenar por cercanía.
    </v-alert>

    <template v-if="!loading">
      <lista-tiendas-mobile v-if="$isMobile()" :tiendas="tiendas" />
      <lista-tiendas v-else :tiendas="tiendas" />

      <v-alert
        v-if="!tiendas || tiendas.length === 0"
        type="info"
        dense
        outlined
        class="tiendas-alert"
      >
        No hay tiendas para mostrar en este momento.
      </v-alert>
    </template>
  </v-container>
</template>
<script>
import ListaTiendasMobile from '../components/mobile/ListaTiendasMobile.vue'
import ListaTiendas from '../components/ListaTiendas.vue'
import { mapActions } from 'vuex'
import { Plugins } from '@capacitor/core'

const { Geolocation } = Plugins

export default {
  components: { ListaTiendasMobile, ListaTiendas },
  name: 'Tiendas',
  methods: {
    ...mapActions('App', ['getTiendas']),
    ...mapActions('App', ['setAppCustomerPosition']),
    async getCustomerPosition (cords) {
      const { latitude, longitude } = cords.coords
      this.setAppCustomerPosition({
        latitude,
        longitude
      })
      this.tiendas = await this.getTiendas()
      this.loading = false
    },
    async handlerGeopositionErros (erros) {
      if (erros.code === 1) {
        this.accesoDenegadoUsuario = true
      }
      try {
        this.tiendas = await this.getTiendas()
      } finally {
        this.loading = false
      }
    },
    getPermissions () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.getCustomerPosition, this.handlerGeopositionErros)
      } else {
        Geolocation.getCurrentPosition()
          .then(coordinates => this.getCustomerPosition(coordinates))
          .catch(async () => {
            try {
              this.tiendas = await this.getTiendas()
            } finally {
              this.loading = false
            }
          })
      }
    }
  },
  data () {
    return {
      tiendas: [],
      franquicias: [],
      loading: true,
      accesoDenegadoUsuario: false
    }
  },
  async mounted () {
    this.loading = true
    this.getPermissions()
  }
}
</script>

<style scoped>
.tiendas-page {
  max-width: 1100px;
  padding-bottom: 32px;
}
.tiendas-top {
  margin-bottom: 16px;
  text-align: left;
}
.page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.87);
}
.page-subtitle {
  margin: 4px 0 0;
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.9rem;
}
.tiendas-skeleton {
  border-radius: 14px;
  overflow: hidden;
}
.tiendas-alert {
  border-radius: 12px !important;
}
</style>
